<template>
  <div>
    <v-row class="px-3">

      <!-- Add Count -->
      <v-col cols="12" class="grey lighten-4 round-corners">
        <v-row no-gutters>
          <v-col cols="6" class="font-weight-bold">
           Etapas de reparación
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn small color="primary" @click="show()" v-if="isEditing">Añadir</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <!-- Table -->
      <v-col cols="12">
        <v-data-table
          :headers="filteredHeaders"
          :items="list"
          class="elevation-0"
          :expanded.sync="expanded"
          single-expand
          item-key="id"
          show-expand
          :key="component"
          :loading="isLoadingData"
          @item-expanded="getFiles($event)"
        >
          <!-- Name -->
          <template v-slot:item.name="{ item }">
            {{ item.name.name }}
          </template>
          <!-- Images Preview -->
          <template v-slot:expanded-item="{ item, headers }">
            <td :colspan="headers.length">
              <v-row class="fill-height ma-0" align="center" justify="center" v-if="isLoadingFiles">
                <v-progress-circular indeterminate color="grey"/>
              </v-row>
              <v-row v-else-if="!files.length">
                <v-col cols="12" class="text-center">
                  <span class="ma-3 font-weight-bold caption">No tiene imágenes</span>
                </v-col>
              </v-row>
              <v-row align="center" v-else>
                <v-col cols="12" class="text-center">
                  <span class="ma-3 font-weight-bold caption">Imágenes</span>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-container class="pt-0">
                    <v-row  class="grey lighten-4">
                      <v-col cols="2" v-for="image in files" :key="image.id">
                        <v-img
                          :src="image.download_url"
                          class="cursor-pointer ma-3" 
                          contain aspect-ratio="1"
                          max-height="70px"
                          @click="show('preview', image)"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0 grey lighten-5" align="center" justify="center" >
                              <v-progress-circular indeterminate color="grey"/>
                            </v-row>
                          </template>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </td>
          </template>
          <!-- Actions -->
          <template v-slot:item.action="{ item }">
            <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon @click="show('delete', item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
      
    </v-row>

    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      width="700px"
    >
      <v-card v-if="dialog">
        <v-card-title primary-title>
          {{ title }} etapa de reparación
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="step" vertical class="pa-0 elevation-0">

            <!-- Data -->
            <v-stepper-step step="1" :editable="!!item.id">Datos</v-stepper-step>
            <v-stepper-content step="1">
              <v-row justify="space-around">
                <!-- Name -->
                <v-col cols="6">
                  <v-autocomplete
                    v-model="item.repair_stage_type_id"
                    :items="options"
                    :error-messages="repairStageTypeErrors"
                    label="Nombre"
                    item-text="name"
                    item-value="id"
                    @blur="$v.item.repair_stage_type_id.$touch()"
                  ></v-autocomplete>
                </v-col>
                <!-- Temperature -->
                <v-col cols="3">
                  <v-text-field
                    v-model="item.temperature_measurement"
                    :error-messages="temperatureErrors"
                    label="Temperatura"
                    suffix="°C"
                    @blur="$v.item.temperature_measurement.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Humidity -->
                <v-col cols="3">
                  <v-text-field
                    v-model="item.humidity_measurement"
                    :error-messages="humidityErrors"
                    label="Humedad"
                    suffix="%"
                    @blur="$v.item.humidity_measurement.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- Images -->
            <v-stepper-step step="2" :editable="!!item.id">Imágenes</v-stepper-step>
            <v-stepper-content step="2">
              <v-row justify="space-around">
                <v-col cols="12">
                  <image-upload
                    :disabled="!item.id"
                    :items="filteredFiles"
                    :loading="isLoadingFiles"
                    externalFooter
                    title="Archivos subidos"
                    @save="uploadFile($event)"
                    @delete="deleteFile($event)"/>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
          <!-- Buttons -->
        <v-card-actions>
          <v-spacer/>
          <v-btn text class="mr-4" @click="close()">Cancelar</v-btn>
          <v-btn color="primary" :disabled="invalid" @click="save()">{{ title }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Preview -->
    <image-preview
      v-model="previewDialog"
      :item="item"
      @close="close('preview')"
    />
    
    <!-- Confirmation -->
    <confirmation
      v-model="deleteDialog"
      title="Eliminar etapa de reparación"
      text="Desea eliminar la etapas de reparación"
      @close="close('delete')"
      @confirm="deleteItem()"
    />
  </div>
</template>

<script>
import Confirmation from "@/components/Confirmation";
import ImageUpload from '@/components/ImageUpload'
import ImagePreview from "@/components/ImagePreview";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Util from "@/util/index";

export default {
  name: 'time-worked-per-damage',
  props: {
    isEditing: Boolean,
    blade_damage_id: Number
  },
  components: {
    Confirmation,
    ImageUpload,
    ImagePreview
  },
  mixins: [validationMixin],
  validations: {
    item: {
      repair_stage_type_id: { required },
      temperature_measurement: { required },
      humidity_measurement: { required },
    },
  },
  data: () => ({
    step: 1,
    component: 0,
    expanded: [],
    dialog: false,
    previewDialog: false,
    deleteDialog: false,
    isLoadingData: false,
    isLoadingFiles: false,
    item: {
      images: []
    },
    file: null,
    image: {},
    headers: [
      { text: "Nombre ", value: "repair_stage_type.name", align: "center" },
      { text: "Temperatura", value: "temperature_measurement", align: "center" },
      { text: "Humedad", value: "humidity_measurement", align: "center" },
      { text: "Acciones", value: "action", sortable: false, align: "center" }
    ],
    fileHeaders: [
      { text: "Nombre", value: "name", align: "center" },
      { text: "Acción", value: "action", sortable: false, align: "center" }
    ],
  }),
  watch: {
    dialog (val) {
      val || this.close()
    },
    blade_damage_id () {
      this.init()
    }
  },
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    isNew () {
      return !this.item.id
    },
    title () {
      return this.isNew ? 'Añadir' : 'Modificar'
    },
    invalid () {
      return this.$v.$invalid && this.$v.$dirty
    },
    list () {
      return this.$store.state.interventions.repairStages.list
        .filter(element => element.blade_damage_id === this.blade_damage_id)
    },
    files() {
      return this.$store.state.interventions.repairStages.files
    },
    filteredFiles() {
      return this.files.filter(element => element.repair_stage_id === this.item.id)
    },
    options () {
      return this.$store.state.interventions.options.repairStageTypes
    },
    filteredHeaders () {
      return this.headers.filter(element => this.isEditing && element.value === 'action' || element.value !== 'action')
    },
    filteredFileHeaders () {
      return this.fileHeaders.filter(element => this.isEditing && element.value === 'action' || element.value !== 'action')
    },
    repairStageTypeErrors () {
      const errors = []
      if (!this.$v.item.repair_stage_type_id.$dirty) return errors
      !this.$v.item.repair_stage_type_id.required && errors.push('Obligatorio.')
      return errors
    },
    temperatureErrors () {
      const errors = []
      if (!this.$v.item.temperature_measurement.$dirty) return errors
      !this.$v.item.temperature_measurement.required && errors.push('Obligatorio.')
      return errors
    },
    humidityErrors () {
      const errors = []
      if (!this.$v.item.humidity_measurement.$dirty) return errors
      !this.$v.item.humidity_measurement.required && errors.push('Obligatorio.')
      return errors
    },
  },
  methods: {
    errorAlert (error, altText) {
      if (error.response.status === 403 ) {
        this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
          color: "error",
          x: "center",
          y: "top",
          icon: "mdi-information",
          timeout: 0,
          showClose: true,
          closeText: "Cerrar"
        });
        this.$router.push({ name: 'home'})
      } else {
        let errorToastMessage = altText
        Util.showErrorToast(this, error, errorToastMessage);
      }
    },
    init () {
      if (this.blade_damage_id) {
        this.isLoadingData = true
        const body = {
          id: this.blade_damage_id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'repairStages'
        }
        this.$store.dispatch('interventions/repairStages/list', body)
          .catch(error => {
            const altText = "Ha ocurrido un error cargando la lista de etapas de reparación"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.isLoadingData = false
            this.component++
          })
      }
    },
    async getFiles(event) {
      const item = event.item
      const value = event.value
      if (item && value) {
        this.isLoadingFiles = true
        const body = {
          repair_stage_id: item.id,
          blade_damage_id: this.blade_damage_id,
          work_intervention_id: this.$route.params.id,
          work_order_id: this.$route.params.work_order,
          with: 'repairStageImages'
        }
        await this.$store.dispatch('interventions/repairStages/getFiles', body)
          .catch(error => {
            const altText = "Ha ocurrido un error cargando las imágenes de etapas de reparación"
            this.errorAlert(error, altText)
          })
          .finally(() => {
            this.component++
            this.loading = false
            this.isLoadingFiles = false
          })
      }
    },
    hasFiles(item) {
      const files = this.files.filter(element => element.repair_stage_id === item.id)
      return files.length > 0
    },
    itemFiles(item) {
      return this.files.filter(element => element.repair_stage_id === item.id)
    },
    show (dialog, item) {
      if (item) this.item = item
      if (dialog === 'delete') this.deleteDialog = true
      else if (dialog === 'preview') this.previewDialog = true
      else this.dialog = true
    },
    close (dialog) {
      if (dialog === 'delete') this.deleteDialog = false
      else if (dialog === 'preview') this.previewDialog = false
      else {
        this.dialog = false
        this.$emit('close', this.list)
      }
      this.item = { images: [] }
      this.$v.$reset()
      this.step = 1
    },
    async editItem (item) {
      this.item = Object.assign({}, item)
      this.loading = true
      await this.getFiles({
        item: item,
        value: true
      })
      this.dialog = true
    },
    deleteItem () {
      this.$store.dispatch('interventions/repairStages/delete', this.item.id)
        .then(() => {
          this.$toast("Etapa de reparación eliminada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.init()
        })
        .catch(error => {
          let altText = "Ha ocurrido un error eliminando la etapa de reparación."
          this.errorAlert(error, altText)
        })
      this.close('delete')
    },
    deleteFile (item) {
      const body = {
        id: item.id,
        repair_stage_id: item.repair_stage_id,
        blade_damage_id: this.blade_damage_id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
      }
      this.$store.dispatch('interventions/repairStages/deleteFile', body)
        .then(() => {
          this.$toast("Imágen borrada correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.getFiles({
            item: this.item,
            value: true
          })
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error borrando la imágen."
          Util.showErrorToast(this, error, errorToastMessage);
        })
    },
    uploadFile (file) {
      const body = {
        repair_stage_id: this.item.id,
        blade_damage_id: this.blade_damage_id,
        work_intervention_id: this.$route.params.id,
        work_order_id: this.$route.params.work_order,
        fileToUpload: file
      }
      this.loading = true
      this.$store.dispatch('interventions/repairStages/uploadFile', body)
        .then(() => {
          this.$toast("Imágen subida correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.file = null
          this.getFiles({
            item: this.item,
            value: true
          })
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error subiendo la imágen."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let item = {
          ...this.item
        }
        delete item.images
        if (this.isNew) {
          item.blade_damage_id = this.blade_damage_id
          await this.$store.dispatch('interventions/repairStages/create', item)
            .then(response => {
              const data = response.data.data
              this.$toast("Etapa de reparación creada correctamente.", {
                color: "success",
                x: "center",
                y: "top",
                icon: "mdi-information"
              });
              this.item = data
              console.log("save -> this.item", this.item)
              this.step++
              this.init()
            })
            .catch(error => {
              let altText = "Ha ocurrido un error creando la etapa de reparación."
              this.errorAlert(error, altText)
            })
        } else {
          await this.$store.dispatch('interventions/repairStages/edit', item)
            .then(() => {
              this.$toast("Etapa de reparación modificada correctamente.", {
                color: "success",
                x: "center",
                y: "top",
                icon: "mdi-information"
              });
              this.init()
            })
            .catch(error => {
              let altText = "Ha ocurrido un error modificando la etapa de reparación."
              this.errorAlert(error, altText)
            })
            .finally(() => {
              this.close()
            })
        }
        this.loading = false
      }
    }
  },
  async created () {
    await this.$store.dispatch('interventions/options/getRepairStageTypes')
      .catch(error => {
        const altText = "Ha ocurrido un error cargando la lista de tipos de etapas de reparación"
        this.errorAlert(error, altText)
      })
    this.init()
  }
}
</script>
